import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-phonenumbers',
  templateUrl: './phonenumbers.component.html',
  styleUrls: ['./phonenumbers.component.css']
})
export class PhonenumbersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
